import { http } from '@/services/http'
import type {
  AcceptLegalRequest,
  AcceptLegalResponse,
  LegalDocument,
  LegalDocumentType,
  PendingAcceptanceResponse,
  UserAcceptance,
} from '@/types/legal'

const BASE_URL = '/legal'

export const legalService = {
  /**
   * Verifica se há documentos legais pendentes de aceite
   */
  getPendingAcceptance: async (): Promise<PendingAcceptanceResponse> => {
    return http.get<PendingAcceptanceResponse>(`${BASE_URL}/pending-acceptance`)
  },

  /**
   * Registra o aceite de um documento legal
   */
  accept: async (data: AcceptLegalRequest): Promise<AcceptLegalResponse> => {
    return http.post<AcceptLegalResponse, AcceptLegalRequest>(`${BASE_URL}/accept`, data)
  },

  /**
   * Busca a versão atual de um documento legal
   */
  getCurrentDocument: async (type: LegalDocumentType): Promise<LegalDocument> => {
    return http.get<LegalDocument>(`${BASE_URL}/documents/${type}/current`)
  },

  /**
   * Lista todos os aceites do usuário
   */
  getMyAcceptances: async (): Promise<UserAcceptance[]> => {
    return http.get<UserAcceptance[]>(`${BASE_URL}/my-acceptances`)
  },
}
